import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, SnackbarContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';

import * as SnackbarActions from '../../actions/snackbar';

const styles = {
  success: {
    backgroundColor: 'red',
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
};

function SnackbarError() {
  const dispatch = useDispatch();
  const { errorSnackbarMessage, errorSnackbarOpen } = useSelector(
    (state) => state.snackbar,
  );

  function handleClose() {
    dispatch(SnackbarActions.clearSnackbar());
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={errorSnackbarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <SnackbarContent
        style={styles.success}
        message={(
          <span id="message-id" style={styles.message}>
            <ErrorIcon style={{ ...styles.icon, ...styles.iconVariant }} sx={{ mr: 2 }} />
            {errorSnackbarMessage}
          </span>
        )}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon style={styles.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}

export default SnackbarError;
